<template>
  <div
    class="zoom-control"
    @wheel.prevent.stop="onWheel"
  >
    <button
      :aria-label="$t('Zoom out')"
      class="zoom-control__zoom-out nebula-button nebula-button--s nebula-button--icon-only"
      :de-tracking-name="deTrackingNameZoomOut"
      @click="decrement"
    >
      <NebulaIcon
        size="s"
        symbol-id="zoom-out"
      />
    </button>
    <input
      ref="input"
      type="range"
      :value="value"
      :min="min"
      :max="max"
      :step="step"
      :aria-label="$t('Zoom')"
      :de-tracking-name="deTrackingNameSlider"
      class="zoom-control__slider"
      @input="onInput"
    >
    <button
      :aria-label="$t('Zoom in')"
      class="zoom-control__zoom-in nebula-button nebula-button--s nebula-button--icon-only"
      :de-tracking-name="deTrackingNameZoomIn"
      @click="increment"
    >
      <NebulaIcon
        size="s"
        symbol-id="zoom-in"
      />
    </button>
    <span class="zoom-control__label">{{ $t('%(value)d%', { value }) }}</span>
  </div>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';

export default {
  components: {
    NebulaIcon,
  },
  props: {
    value: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    deTrackingNameSlider: {
      type: String,
      default: '',
    },
    deTrackingNameZoomIn: {
      type: String,
      default: '',
    },
    deTrackingNameZoomOut: {
      type: String,
      default: '',
    },
  },
  emits: ['input'],
  methods: {
    onInput(event) {
      this.$emit('input', parseInt(event.target.value, 10));
    },
    onWheel(event) {
      if (event.deltaY < 0) {
        this.increment();
      } else {
        this.decrement();
      }
    },
    increment() {
      let incremented = this.value + this.step;
      if (incremented > this.max) incremented = this.max;
      this.$refs.input.value = incremented;
      this.$emit('input', incremented);
    },
    decrement() {
      let decremented = this.value - this.step;
      if (decremented < this.min) decremented = this.min;
      this.$refs.input.value = decremented;
      this.$emit('input', decremented);
    },
  },
};
</script>

<style lang="stylus">
.zoom-control {
  align-items: center;
  display: flex;
  height: 30px;
  width: 290px;

  .zoom-control__slider {
    -webkit-appearance: none;
    appearance: none;
    background: $nebula-color-neutral-100;
    border-radius: ($nebula-border-radius-default / 4);
    flex: 1;
    height: 8px;
    margin: 0 ($nebula-space-1x * 1.5);
    min-width: 50px;
  }

  .zoom-control__slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: $nebula-color-interface-blue-200;
    border-radius: 50%;
    cursor: pointer;
    height: 15px;
    width: 15px;
  }

  .zoom-control__slider::-moz-range-thumb {
    background: $nebula-color-interface-blue-200;
    border-radius: 50%;
    border-width: 0;
    cursor: pointer;
    height: 15px;
    width: 15px;
  }

  .zoom-control__zoom-in, .zoom-control__zoom-out {
    background-color: transparent;
    fill: $nebula-color-neutral-100;
    padding: $nebula-space-half;
  }

  .zoom-control__label {
    align-items: center;
    color: $nebula-color-neutral-100;
    display: flex;
    font-size: 14px;
    justify-content: center;
    text-align: center;
    width: 60px;
  }
}
</style>
